import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

import logo from '@/assets/logo.png';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { error } = await signIn(email, password);
      if (error) throw error;
      navigate('/');
    } catch (error: any) {
      const message =
        error.message === 'Invalid login credentials'
          ? 'Неверный логин или пароль'
          : error.message === 'Invalid authentication credentials'
            ? 'Ошибка подключения к серверу авторизации (неверные ключи/настройки backend)'
            : error.message || 'Произошла ошибка';
      setError(message);

    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen bg-slate-100 dark:bg-slate-900 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 p-8 rounded-3xl shadow-xl w-full max-w-md">
        <div className="text-center mb-8">
          <img src={logo} alt="Travel Ease" className="w-44 h-auto mx-auto mb-1" />
          <p className="text-slate-500 dark:text-slate-400">
            Вход в систему
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {error && (
            <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-900 text-red-500 text-sm rounded-xl text-center font-medium">
              {error}
            </div>
          )}

          <div>
            <label htmlFor="email-input" className="text-xs font-bold text-slate-600 dark:text-slate-400 uppercase ml-1">Email</label>
            <Input
              id="email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full"
              required
            />
          </div>

          <div>
            <label htmlFor="password-input" className="text-xs font-bold text-slate-600 dark:text-slate-400 uppercase ml-1">Пароль</label>
            <Input
              id="password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full py-6 text-lg bg-blue-700 hover:bg-blue-800"
            disabled={loading}
          >
            {loading ? 'Загрузка...' : 'Войти'}
          </Button>
        </form>

        <div className="mt-6 text-center text-xs text-slate-600 dark:text-slate-400 space-y-2">
          <p>Для создания аккаунта обратитесь к администратору</p>
          <p className="text-[10px] text-slate-400 dark:text-slate-500">
            Входя в систему, вы соглашаетесь с{' '}
            <Link 
              to="/terms-of-service" 
              className="text-blue-600 dark:text-blue-400 hover:underline"
            >
              Пользовательским соглашением
            </Link>
            {' '}и{' '}
            <Link 
              to="/privacy-policy" 
              className="text-blue-600 dark:text-blue-400 hover:underline"
            >
              Политикой конфиденциальности
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}